import {usePermissions} from './usePermissions/usePermissions';

interface LicenceStatus {
  isSalesModuleEnabled: boolean;
  isRentalVehicleModuleEnabled: boolean;
  isCarPassEnabled: boolean;
  isWorkshopModuleEnabled: boolean;
  isWarehouseModuleEnabled: boolean;
  isAdvertisingEnabled: boolean;
  isVehicleWarehouseModuleEnabled: boolean;
  isPriceReportEnabled: boolean;
}

export const useIsLicenceEnabled = (): LicenceStatus => {
  const [
    canReadBusinessCase,
    canReadRentalVehicle,
    canReadCarPassRequest,
    canReadWorkshop,
    canReadArticle,
    canToggleTenantPlatform,
    canReadVehicleWarehouse,
    canSetPurchasePriceCosts,
  ] = usePermissions({
    permissionKeys: [
      'businessCaseRead',
      'readRentalVehicle',
      'canReadCarPassRequest',
      'workshopRead',
      'articleRead',
      'toggleTenantPlatform',
      'vehicleWarehouseRead',
      'setPurchasePriceCosts',
    ],
  });

  const isSalesModuleEnabled = canReadBusinessCase;
  const isRentalVehicleModuleEnabled = canReadRentalVehicle;
  const isCarPassEnabled = canReadCarPassRequest;
  const isWorkshopModuleEnabled = canReadWorkshop;
  const isWarehouseModuleEnabled = canReadArticle;
  const isAdvertisingEnabled = canToggleTenantPlatform;
  const isVehicleWarehouseModuleEnabled = canReadVehicleWarehouse;
  const isPriceReportEnabled = canSetPurchasePriceCosts;

  return {
    isSalesModuleEnabled,
    isRentalVehicleModuleEnabled,
    isCarPassEnabled,
    isWorkshopModuleEnabled,
    isWarehouseModuleEnabled,
    isAdvertisingEnabled,
    isVehicleWarehouseModuleEnabled,
    isPriceReportEnabled,
  };
};
